import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Rosario, Santa Fe',
    quote: 'Llevaba 4 años rechazado en todos los bancos. Seguí el Protocolo Salir del Veraz al pie de la letra y en 30 días el dato negativo desapareció del Veraz. Hoy tengo mi tarjeta de crédito aprobada. No lo podía creer.'
  }, {
    initials: 'MT',
    name: 'Marcela T.',
    location: 'CABA, Buenos Aires',
    quote: 'Los estudios de cobranza me llamaban hasta 8 veces por día por una deuda de 2013. Usé el script del Bono 4 y les mandé la carta de cese. Las llamadas pararon en 48 horas.'
  }, {
    initials: 'DF',
    name: 'Diego F.',
    location: 'Córdoba Capital',
    quote: 'Pensé que tenía que pagar sí o sí para salir del problema. El Tomo 2 me mostró que la deuda ya había caducado legalmente. No pagué un solo peso y el dato se eliminó.'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-305">
      <div className="max-w-3xl w-full" data-id="element-306">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-307">
          <div className="text-brand-gold text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-308">
            TESTIMONIOS
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-309">
            Personas que ya usaron el{' '}
            <span className="text-brand-gold" data-id="element-310">Protocolo</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-311">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="flex flex-col p-4 rounded-lg border border-brand-gold/15 hover:border-brand-gold/40 hover:shadow-[0_0_20px_rgba(201,168,76,0.06)] transition-all duration-300" style={{
          background: 'linear-gradient(135deg, #0d0b08 0%, #0a0a0a 100%)'
        }} data-id="element-312">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-313">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-black font-bold text-[10px] shrink-0" style={{
              background: 'linear-gradient(135deg, #e8d48b 0%, #c9a84c 50%, #a8862a 100%)'
            }} data-id="element-314">
                  {testimonial.initials}
                </div>
                <div data-id="element-315">
                  <h4 className="text-white font-bold text-xs leading-tight" data-id="element-316">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-500 text-[10px]" data-id="element-317">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <div className="text-[10px] tracking-widest mb-2" data-id="element-318">⭐⭐⭐⭐⭐</div>
              <p className="text-gray-400 text-xs leading-relaxed italic" data-id="element-319">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}